import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ModulesState } from '../reducers/modules.reducer';
import { MODULES_FEATURE_KEY } from '../keys';

const selectState = createFeatureSelector<ModulesState>(MODULES_FEATURE_KEY);

export const selectLoaded = createSelector(selectState, (state: ModulesState) => state.loaded);
export const selectLoading = createSelector(selectState, (state: ModulesState) => state.loading);
export const selectModules = createSelector(selectState, (state: ModulesState) => state.modules);
export const selectTotal = createSelector(selectState, (state: ModulesState) => state.total);
export const selectPage = createSelector(selectState, (state: ModulesState) => state.page);
export const selectLimit = createSelector(selectState, (state: ModulesState) => state.limit);
export const selectLastParams = createSelector(selectState, (state: ModulesState) => state.lastParams);
